module.exports = __webpack_public_path__ + "assets/img/travel-day43.356a1935.png";